import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

const SecurityHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Gestión de Seguridad"
    text="Éste es el módulo de Gestión de Seguridad."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

const mapStateToProps = ({ SecurityUnit }) => ({
  cards: SecurityUnit.UnitHome.get('cards'),
  breadcrumbs: SecurityUnit.UnitHome.get('breadcrumbs'),
});

SecurityHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(SecurityHome);
